// Runtime API key discovered at app boot (per-domain account).
// Persist in localStorage so new tabs (payment return flows) can reuse it
// before bootstrap resolves the store again.

const RUNTIME_API_KEY_STORAGE = 'bytz.runtimeApiKey';

let runtimeApiKey = null;

function readStoredApiKey() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(RUNTIME_API_KEY_STORAGE);
    return typeof raw === 'string' && raw.trim() ? raw.trim() : null;
  } catch {
    return null;
  }
}

function writeStoredApiKey(value) {
  if (typeof window === 'undefined') return;
  try {
    if (value) window.localStorage.setItem(RUNTIME_API_KEY_STORAGE, value);
    else window.localStorage.removeItem(RUNTIME_API_KEY_STORAGE);
  } catch {
    // Ignore storage failures.
  }
}

export function getRuntimeApiKey() {
  if (!runtimeApiKey) {
    runtimeApiKey = readStoredApiKey();
  }
  return runtimeApiKey;
}

export function setRuntimeApiKey(apiKey) {
  runtimeApiKey = typeof apiKey === 'string' && apiKey.trim() ? apiKey.trim() : null;
  writeStoredApiKey(runtimeApiKey);
}
